export const messageColors = [
    {
        name: 'Warning',
        value: 'warning'
    },
    {
        name: 'Info',
        value: 'info'
    },
    {
        name: 'Positive',
        value: 'positive'
    },
    {
        name: 'Success',
        value: 'success'
    },
    {
        name: 'Negative',
        value: 'negative'
    },
    {
        name: 'Error',
        value: 'error'
    },
    {
        name: 'Red',
        value: 'red'
    },
    {
        name: 'Orange',
        value: 'orange'
    },
    {
        name: 'Yellow',
        value: 'yellow'
    },
    {
        name: 'Olive',
        value: 'olive'
    },
    {
        name: 'Green',
        value: 'green'
    },
    {
        name: 'Teal',
        value: 'teal'
    },
    {
        name: 'Blue',
        value: 'blue'
    },
    {
        name: 'Violet',
        value: 'violet'
    },
    {
        name: 'Purple',
        value: 'purple'
    },
    {
        name: 'Pink',
        value: 'pink'
    },
    {
        name: 'Brown',
        value: 'brown'
    },
    {
        name: 'Black',
        value: 'black'
    }
];